module.exports = __webpack_public_path__ + "img/smithfield-logo.77c45e99.jpg";